import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

export const PERCS_CARD_MAX_WIDTH = 450;
export const PERCS_CARD_MIN_WIDTH = 320;
export const PERCS_CARD_MIN_HEIGHT_DESKTOP = 498;
export const PERCS_CARD_MIN_HEIGHT_MOBILE = 506;
export const PERCS_CARD_PADDING_VERTICAL = 48;

export default styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '48px 18px',
  borderTopLeftRadius: '60px',
  borderTopRightRadius: '60px',
  textAlign: 'center',
  maxWidth: PERCS_CARD_MAX_WIDTH,
  minWidth: PERCS_CARD_MIN_WIDTH,
  minHeight: PERCS_CARD_MIN_HEIGHT_DESKTOP,
  [legacyTheme.breakpoints.match('sm')]: {
    minHeight: PERCS_CARD_MIN_HEIGHT_MOBILE,
  },
  margin: '0 6px',
  backgroundColor: theme.colors.primary[100],
});
